// gnav
$(function() {
  var $gnav = $('#js-gnav');
  // var $gnavList = $gnav.find('.p-gnav__list');
  var $gnavTrigger = $('#js-gnav-trigger');
  if ($gnav.length && $gnavTrigger.length) {
    var $gnavCloseTrigger = $('#js-gnav-close-trigger, #js-gnav li a');
    var $body = $('body');
    var $header = $('#js-header');
    $gnavTrigger.on('click', function() {
      $(this).toggleClass('is-active');
      if ($(this).hasClass('is-active')) {
        $gnav.addClass('is-active');
        $header.addClass('border-is-visible');
        $body.addClass('gnav-is-active');
      } else {
        $gnav.removeClass('is-active');
        $body.removeClass('gnav-is-active');
        $header.removeClass('border-is-visible');
      }
    });
    $gnavCloseTrigger.on('click', function() {
      $gnav.removeClass('is-active');
      $gnavTrigger.removeClass('is-active');
      $body.removeClass('gnav-is-active');
      $header.removeClass('border-is-visible');
    });
  } else {
    console.log('gnav is not exist');
  }
});
